import { ConnectWalletButton } from '@apeiron/auth'
import { useAccountContext } from '@apeiron/temp'
import { Box, styled, Typography } from '@mui/material'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

const MainContainer = styled(Box)`
  width: 100%;
  height: fit-content;

  background-color: rgba(0, 0, 0, 0.8);

  border-radius: 12px;

  display: flex;
  flex-direction: column;
  gap: 20px;

  ${props => props.theme.breakpoints.up('res1024')} {
    padding: 30px 80px 10px 60px;
  }

  ${props => props.theme.breakpoints.down('res1024')} {
    padding: 20px;
  }
`

const Title = styled(Typography)`
  font-size: 32px;
  line-height: 1;
`

const Subtitle = styled(Typography)`
  font-size: 15px;
  line-height: 1;

  color: rgba(255, 255, 255, 0.7);
`

const ConnectButton = styled(ConnectWalletButton)`
  width: 410px;
  margin-top: 12px;
  padding: 16px 0px;

  margin-left: unset;

  ${props => props.theme.breakpoints.down('res1024')} {
    width: 100%;
  }
`

const VipPassConnectWalletSection = () => {
  const { t } = useTranslation()

  const { bindWalletAddress } = useAccountContext()

  const handleClick = useCallback(async () => {
    bindWalletAddress()
  }, [bindWalletAddress])

  return (
    <MainContainer>
      <Title>{t('vip_pass.connect_wallet.title')}</Title>
      <Subtitle>{t('vip_pass.connect_wallet.subtitle')}</Subtitle>
      <ConnectButton
        text={t('vip_pass.connect_wallet.button')}
        onClick={handleClick}
      />
    </MainContainer>
  )
}

export default VipPassConnectWalletSection
